// utils/localStorage.ts
export function getFromStorage<T>(key: string, defaultValue: T): T {
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
    } catch {
        return defaultValue;
    }
}

export function setToStorage<T>(key: string, value: T): void {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error('Error saving to localStorage:', error);
    }
}

export function existsInStorage(key: string): boolean {
    return window.localStorage.getItem(key) !== null;
}

export function removeFromStorage(key: string): void {
    window.localStorage.removeItem(key);
}

export const localStorageUtils = {
    exists: existsInStorage,
    get: getFromStorage,
    set: setToStorage,
    remove: removeFromStorage,
};
